// extracted by mini-css-extract-plugin
module.exports = {"typing":"_23RuT","background":"Aes0h","content":"_33O0D","wrapper":"w4xL8","member":"_2it4A","separator":"rpLFU"};